import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';

import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-requests-page',
  templateUrl: './requests-page.component.html',
  styleUrls: ['./requests-page.component.sass']
})
export class RequestsPageComponent implements OnInit {

  columns: Array<any> = [
    {
      title: 'Component Name',
      name: 'Name',
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by name'
      },
      width: '320px'
    },
    {
      title: 'Scanned Version',
      name: 'RequestVersion',
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by version'
      }
    },
    {
      title: 'Response Version',
      name: 'ResponseVersion',
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by version',
        filterEmpty: false
      }
    },
    {
      title: 'Details',
      name: 'Details',
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by details'
      },
      width: '320px'
    },
    {
      title: 'Error Description',
      name: 'ErrorDesc',
      sort: '',
      filtering: {
        filterType: 'text',
        placeholder: 'Filter by error'
      }
    }
  ];

  config: any = {
    paging: true,
    sorting: { columns: this.columns },
    className: ['table-striped', 'table-bordered'],
    filtering: { filterString: '' }
  };

  public responseFilterData = 
  [
    {
      label: 'Only with response', 
      filter: 0
    },
    {
      label: 'Only without response', 
      filter: 1
    }
  ];
  public selectedResponseFilter: any;

  private componentsRawData: Array<any> = [];
  public componentsFilteredData: Array<any> = [];

  constructor(
    private api: ApiService, 
    private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit(): void {    
    const { id } = this.route.snapshot.params;
    const { time } = this.route.snapshot.queryParams;

    this.api.get(
      `requests/${id}/components?time=${time}`, 
      (result: Array<any>) => {
        this.componentsRawData = result;
        this.changeResponseFilter();
      }
    );
  }

  onShowOnlyWithResponseChange(event: Event) {
    this.columns.find(column => column.name === 'ResponseVersion').filtering.filterEmpty = event.target['checked'];
    this.columns = [...this.columns];
  }

  onClose() {
    this.location.back();
  }

  changeResponseFilter() {
    this.componentsFilteredData = this.componentsRawData;
    
    if (this.selectedResponseFilter) {
      switch (this.selectedResponseFilter.filter) {
        case 0:
          this.componentsFilteredData = this.componentsRawData.filter(item => item.ResponseVersion);
          break;
        case 1:
          this.componentsFilteredData = this.componentsRawData.filter(item => !item.ResponseVersion);
          break;
      }
    }    
  }
  
}
